import _ from 'lodash'
import { resolvePlayerAssetUrl } from '@/lib/player-api'
import type { CasinoGame } from '@/types/casino'

export interface CasinoGameBadge {
	label: string
	className: string
}

export function hasCasinoGameImage(game: CasinoGame): boolean {
	return Boolean(game.image_url || game.image_reg_url || game.image_hq_url)
}

export function getCasinoGameImageUrl(game: CasinoGame): string {
	const imagePath = game.image_hq_url || game.image_reg_url || game.image_url

	return resolvePlayerAssetUrl(imagePath ?? '')
}

export function getCasinoGamePlaceholderImageUrl(game: CasinoGame): string {
	const imagePath = game.image_url || game.image_reg_url || game.image_hq_url

	return resolvePlayerAssetUrl(imagePath ?? '')
}

export function getCasinoGameBadge(game: CasinoGame): CasinoGameBadge | null {
	const label = _.toUpper(game.label)

	if (label === 'NEW' || game.is_new) {
		return { label: 'NEW', className: 'bg-success text-primary-foreground' }
	}

	if (label === 'HOT' || game.is_popular) {
		return { label: 'HOT', className: 'bg-warning text-foreground' }
	}

	if (label === 'TOP' || game.is_recommended) {
		return { label: 'TOP', className: 'bg-pink text-foreground' }
	}

	return null
}
